import React, { useState } from "react";
import { LogOut, FileText } from "lucide-react";
import MemberLogsModal from '../MemberLogsModal';

const RoomMembersList = ({ room, leaveRoom, currentUserId }) => {
  const [selectedMember, setSelectedMember] = useState(null);

  return (
    <>
      <div className="space-y-2 max-h-96 overflow-y-auto pr-2">
        {room.members?.map((member, index) => {
          const userData = member.user;
          if (!userData) return null;

          const memberId = userData._id?.toString() || userData.id?.toString();
          const isCurrentUser = userData.firebaseUid === currentUserId || memberId === currentUserId;

          const displayName = userData.fullName || `${userData.firstName} ${userData.lastName}`.trim() || "이름 정보 없음";
          const displayEmail = userData.email || "이메일 정보 없음";
          const displayInitial = (userData.firstName || "U").charAt(0).toUpperCase();

          return (
            <div
              key={memberId || index}
              className="flex items-center justify-between p-4 transition-colors duration-200 rounded-lg hover:bg-slate-100 border border-transparent hover:border-blue-200"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-blue-200 flex items-center justify-center text-blue-700 font-bold">
                  {displayInitial}
                </div>
                <div>
                  <p className="font-semibold text-gray-800">{displayName}</p>
                  <p className="text-sm text-gray-500">{displayEmail}</p>
                </div>
              </div>

              <div className="flex items-center gap-2">
                {isCurrentUser && leaveRoom && (
                  <button
                    onClick={leaveRoom}
                    className="px-3 py-1.5 bg-orange-500 text-white rounded-lg hover:bg-orange-600 font-medium text-sm flex items-center gap-1.5 transition-colors"
                    title="방 나가기"
                  >
                    <LogOut size={16} />
                    방 나가기
                  </button>
                )}
                <span className="px-3 py-1 text-xs font-bold leading-none text-green-800 bg-green-100 rounded-full">
                  멤버
                </span>
                <button
                  onClick={() => setSelectedMember({ id: memberId, name: displayName })}
                  className="px-3 py-2 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg hover:from-blue-600 hover:to-blue-700 font-medium text-sm flex items-center gap-1.5 transition-all shadow-sm hover:shadow-md"
                  title="활동 로그 보기"
                >
                  <FileText size={16} />
                  로그
                </button>
              </div>
            </div>
          );
        })}
      </div>
      {selectedMember && (
        <MemberLogsModal
          roomId={room._id}
          memberId={selectedMember.id}
          memberName={selectedMember.name}
          onClose={() => setSelectedMember(null)}
        />
      )}
    </>
  );
};

export default RoomMembersList;
